/**
 * This script adds a fix for the dynamic featured product section 
 * to ensure variant selection works correctly and "Add to Bag" 
 * button remains enabled for available variants.
 */
(function() {
  // This function runs when the page loads to fix the dynamic featured product section
  function fixDynamicFeaturedProduct() {
    const featuredProductSections = document.querySelectorAll('.dynamic-featured-product');
    
    if (!featuredProductSections.length) return;
    
    // Loop through all featured product sections
    featuredProductSections.forEach(section => {
      // Get the product form elements
      const productForm = section.querySelector('product-form');
      const addToCartForm = section.querySelector('form[action="/cart/add"]');
      
      if (!productForm || !addToCartForm) return;
      
      // Get the variant selector and submit button
      const variantSelectors = section.querySelectorAll('variant-radios, variant-selects');
      const variantIdInput = addToCartForm.querySelector('input[name="id"]');
      const submitButton = addToCartForm.querySelector('.product-form__submit');
      
      if (!submitButton || !variantIdInput) return;
      
      // Initial fix - ensure the variant ID input is never disabled
      variantIdInput.disabled = false;
      
      // Ensure the button is enabled if we have a valid variant
      function updateSubmitButton() {
        // Only disable the button if the current variant is actually unavailable
        if (variantIdInput && variantIdInput.value) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
          
          // Update button text to show "Add to Bag"
          const buttonTextSpan = submitButton.querySelector('span');
          if (buttonTextSpan) {
            buttonTextSpan.textContent = window.theme && window.theme.strings ? 
              window.theme.strings.addToBag || 'Add to Bag' : 
              'Add to Bag';
          }
        }
      }

      // Function to synchronize variant selection to the form
      function syncVariantSelection() {
        // Get the selected variant ID from the variant selector
        variantSelectors.forEach(selector => {
          // For variant-radios or variant-selects custom elements
          if (selector.currentVariant && selector.currentVariant.id) {
            variantIdInput.value = selector.currentVariant.id;
            variantIdInput.disabled = false;
            console.log('Setting variant ID to:', selector.currentVariant.id);
          }
        });
      }
      
      // Fix for variant change events
      variantSelectors.forEach(selector => {
        // Listen for the change event on the variant selector
        selector.addEventListener('change', function() {
          // Wait a bit for the variant selection to process
          setTimeout(() => {
            // Sync the variant ID from the selector to the form input
            syncVariantSelection();
            
            // Ensure the input is enabled
            variantIdInput.disabled = false;
            updateSubmitButton();
          }, 50);
        });
      });
      
      // Intercept the native variant-selects and variant-radios updateVariantInput method
      // to ensure our form gets updated too
      variantSelectors.forEach(selector => {
        if (selector.updateVariantInput) {
          // Store the original method
          const originalUpdateVariantInput = selector.updateVariantInput;
          
          // Override with our version that also updates our form
          selector.updateVariantInput = function() {
            // Call the original method first
            originalUpdateVariantInput.apply(this, arguments);
            
            // Now update our form's input too
            if (this.currentVariant && this.currentVariant.id) {
              variantIdInput.value = this.currentVariant.id;
              variantIdInput.disabled = false;
              console.log('Variant updated via updateVariantInput to:', this.currentVariant.id);
            }
          };
        }
      });
      
      // Fix for form submissions
      addToCartForm.addEventListener('submit', function(event) {
        // Sync variant selection right before submission
        syncVariantSelection();
        
        // Ensure the variant ID input is enabled when submitting
        variantIdInput.disabled = false;
      }, true); // Use capture to run before other handlers
      
      // Fix on initial load
      updateSubmitButton();
      syncVariantSelection();
      
      // Setup a mutation observer to detect when button is disabled by other scripts
      const buttonObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'disabled' || mutation.attributeName === 'aria-disabled') {
            // Re-enable the button if a variant is selected
            if (variantIdInput && variantIdInput.value) {
              submitButton.removeAttribute('disabled');
              submitButton.removeAttribute('aria-disabled');
            }
          }
        });
      });
      
      // Also observe the variant input to ensure its value is synchronized
      const inputObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'value' || mutation.attributeName === 'disabled') {
            // If another script changes the input value or disabled state, sync from variant selector
            syncVariantSelection();
          }
        });
      });
      
      // Observe the submit button for attribute changes
      buttonObserver.observe(submitButton, { attributes: true });
      
      // Observe the variant input for attribute changes
      inputObserver.observe(variantIdInput, { attributes: true });
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDynamicFeaturedProduct);
  } else {
    fixDynamicFeaturedProduct();
  }
  
  // Also run when the document is fully loaded (images, styles, etc.)
  window.addEventListener('load', fixDynamicFeaturedProduct);
})();
